export default "__VITE_ASSET__ByXCGSXa__"